import { render, staticRenderFns } from "./PointsTopUp.vue?vue&type=template&id=695151e0&scoped=true&"
import script from "./PointsTopUp.vue?vue&type=script&lang=js&"
export * from "./PointsTopUp.vue?vue&type=script&lang=js&"
import style0 from "./PointsTopUp.vue?vue&type=style&index=0&id=695151e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695151e0",
  null
  
)

export default component.exports